import React from 'react';
import '../../css/style.css';

const CustomLoader = () => {
  const bubbles = Array.from({ length: 8 });
  return (
    <div className="loader-wrapper">
      <div className="loader-container">
        <div className="loader">
          {bubbles.map((_, index) => (<div key={index}  style={{'--i': index,}}><span></span></div>))} 
        </div>
      </div>
    </div>
  );
};

export default CustomLoader;
